import { createSlice } from "@reduxjs/toolkit";

const termsAndConditionsFilterSlice = createSlice({
  name: "termsAndConditionsFilter",

  initialState: {
    main_category_id: null,
    category_id: null,
    sub_category_id: null,
  },

  reducers: {
    setTermsAndConditionsFilters: (state, action) => {
      const {
        main_category_id,
        category_id,
        sub_category_id,
      } = action.payload;

      if (main_category_id !== undefined)
        state.main_category_id = main_category_id;

      if (category_id !== undefined)
        state.category_id = category_id;

      if (sub_category_id !== undefined)
        state.sub_category_id = sub_category_id;
    },

    clearTermsAndConditionsFilters: (state) => {
      state.main_category_id = null;
      state.category_id = null;
      state.sub_category_id = null;
    },
  },
});

export const {
  setTermsAndConditionsFilters,
  clearTermsAndConditionsFilters,
} = termsAndConditionsFilterSlice.actions;

export const selectTermsAndConditionsState = (state) =>
  state.termsAndConditionsFilter;

export default termsAndConditionsFilterSlice.reducer;